import React, { useState } from "react";
import Barra from "../components/Barra";
import PanelAdmisiones from "../components/PanelAdmisiones";
import PanelFueraDeHora from "../components/PanelFueraDeHora";

const TABS = [
  { clave: "alumnos", texto: "👥 Alumnos" },
  { clave: "fuera", texto: "🕒 Fuera de hora" },
];

export default function Admisiones() {
  const [tab, setTab] = useState("alumnos");
  return (
    <div className="app-shell">
      <Barra titulo="Admisiones" tabs={TABS} tab={tab} onTab={setTab} />
      {tab === "alumnos" ? <PanelAdmisiones /> : <PanelFueraDeHora />}
    </div>
  );
}
